import { useState, useEffect } from "react";
import axios from "axios";
import { Bell, ArrowUp, ArrowDown, Warning } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AlertBanner() {
  const [alerts, setAlerts] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const res = await axios.get(`${API}/alerts`);
        setAlerts(res.data || []);
      } catch { /* ignore */ }
    };
    fetchAlerts();
  }, []);

  if (alerts.length === 0) return null;

  return (
    <div className="border border-amber-200 dark:border-amber-900 bg-amber-50 dark:bg-amber-950/30 mb-6" data-testid="alert-banner">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 text-left"
        data-testid="alert-toggle"
      >
        <div className="flex items-center gap-2">
          <Warning size={16} weight="bold" className="text-amber-600 dark:text-amber-400" />
          <span className="text-sm font-mono font-medium text-amber-800 dark:text-amber-300">
            {alerts.length} Compliance Alert{alerts.length > 1 ? "s" : ""}
          </span>
        </div>
        <span className="text-xs font-mono text-amber-600 dark:text-amber-400">
          {expanded ? "COLLAPSE" : "VIEW"}
        </span>
      </button>

      {expanded && (
        <div className="border-t border-amber-200 dark:border-amber-900">
          {alerts.slice(0, 10).map((alert) => (
            <div
              key={alert.id}
              className="px-4 py-3 border-b border-amber-100 dark:border-amber-900/50 last:border-b-0"
              data-testid={`alert-${alert.ticker}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-mono font-medium text-amber-900 dark:text-amber-200">
                  {alert.ticker}
                </span>
                <span className="text-xs text-amber-700 dark:text-amber-400">
                  {alert.company_name}
                </span>
              </div>
              <div className="flex flex-wrap gap-2">
                {alert.changes?.map((c, i) => (
                  <span key={i} className="inline-flex items-center gap-1 text-xs font-mono text-amber-800 dark:text-amber-300">
                    {c.field}: {c.from}
                    <ArrowDown size={10} className="text-amber-600" />
                    {c.to}
                  </span>
                ))}
              </div>
              {alert.previous_verdict !== alert.current_verdict && (
                <div className="mt-1 text-xs font-mono">
                  <span className={alert.current_verdict === "halal" ? "text-green-700 dark:text-green-400" : "text-red-700 dark:text-red-400"}>
                    Verdict changed: {alert.previous_verdict?.toUpperCase()} → {alert.current_verdict?.toUpperCase()}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
